import React from "react";
import { Typography } from "@mui/material";

export const BUSINESS_FUNDING = "Business Funding";
export const NO_CREDIT_NEEDED = "No Credit Needed";

export const HeaderText = ({ text }) => <p>{text}<span className="text-boost-primary-400">.</span></p>;

export const HeaderTextDesktop = ({ text, belowSm }) => {
  return (
    <div
      className="font-bold"
      // eslint-disable-next-line no-nested-ternary
      style={{ fontSize: belowSm ? 36 : 63, letterSpacing: -0.25, lineHeight: 1.1 }}
    >
      <HeaderText text={text} />
    </div>
  );
};

export const HeaderTextMobile = ({ text, highlight = false }) =>  (
  <Typography
    component="span"
    sx={{
      color: highlight ? "rgba(142, 109, 247, 1)" : "rgba(255, 255, 255, 1)",
      textShadow: "0px 0px 24px rgba(142, 109, 247, 1)",
      fontSize: "28px",
      fontWeight: 800,
      fontFamily: "Gilroy",
    }}>
    <HeaderText text={text} />
  </Typography>
);
